<template>
  <div>
    <ActionHeader
      v-if="isMobile"
      page-header>
      Confirm Return
    </ActionHeader>
    <div
      v-else
      class="mx-md">
      <BackButton
        :back-default-route="{ name: 'closet' }"
        class="back-button"
        with-border/>
      <div class="d-flex title align-items-center justify-content-center">
        <h4 class="mb-0 w-100 text-center">
          Confirm Return
        </h4>
      </div>
    </div>
    <AppMessage
      class="text-center w-100"
      :class="{ 'mt-lg': !isMobile }"
      variant="brand">
      <p class="semi-bold mb-0">
        One last check!
      </p>
      Confirm that you'd like to return the following items.
    </AppMessage>
    <div
      v-if="isMobile"
      class="col mb-xl pb-lg">
      <div
        v-for="item in itemsToReturn"
        :key="item.id"
        class="row">
        <ReviewPackageItemCard
          class="pt-4"
          :package-item="item"
          :selected="false"
          :selectable="false"/>
      </div>
    </div>
    <div
      v-else
      class="row mt-lg">
      <div
        v-for="item in itemsToReturn"
        :key="item.id"
        class="col col-6 mb-md">
        <ReviewPackageItemCard
          class="border-0"
          :package-item="item"
          :selected="false"
          :selectable="false"/>
      </div>
    </div>
    <div
      :class="isMobile
        ? 'col col-12 mobile-button swap-review-button'
        : 'd-flex justify-content-end mt-md mb-md me-md'">
      <AppMessage
        v-if="errors.length"
        class="text-center"
        variant="danger">
        {{ errors.join('. ') }}
      </AppMessage>
      <SequinButton
        mobile-block
        :disabled="checkoutLoading"
        @click="onReturn">
        Confirm Return
      </SequinButton>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import useScreenSize from '@shared/composables/screenSize.js'
import ActionHeader from '../global/sequin/ActionHeader.vue'
import AppMessage from '../global/sequin/AppMessage.vue'
import BackButton from '../global/sequin/BackButton.vue'
import ReviewPackageItemCard from '../review/ReviewPackageItemCard.vue'
import SequinButton from '../global/sequin/SequinButton.vue'
import { useQuarterlyRentalsStore } from '@/stores/quarterlyRentals.js'
import { useCaseStore } from '@/stores/case.js'
import { useFlyouts } from '@/composables/flyouts'
import { useLogger } from 'vue-logger-plugin'

const logger = useLogger()
const router = useRouter()
const quarterlyRentalsStore = useQuarterlyRentalsStore()
const caseStore = useCaseStore()
const { itemsToReturn, errors, checkoutLoading } = storeToRefs(quarterlyRentalsStore)
const { isMobile } = useScreenSize()
const { openMyCaseFlyout } = useFlyouts()
async function onReturn () {
  try {
    await quarterlyRentalsStore.returnItems()
    await router.push({ name: 'closet-sections' })
    caseStore.setCoreTabById('quarterly-rentals')
    await openMyCaseFlyout('core')
  } catch (err) {
    logger.error('Error returning items', err)
  }
}
</script>

<style lang="scss" scoped>
  .mobile-button {
    padding: 12px;
    border-top: $default-border;
    background-color: $white;
    z-index: 2;
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .list-padding {
    padding-bottom: 128px;
  }

.back-button {
  position: relative;
  bottom: -38px;
}
.title {
  height: 38px;
}
</style>
